var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", { staticClass: "boss-table-data pega-break" }, [
      _c("span", { attrs: { "data-test": "file-name" } }, [
        _vm._v(_vm._s(_vm.summaryFile.name)),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { "data-test": "file-size" } }, [
        _vm._v(_vm._s(_vm._f("formatSize")(_vm.summaryFile.size))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data text-center",
        attrs: { "data-test": "file-sent" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("formatDateTime")(_vm.summaryFile.sentDate)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data text-center",
        attrs: { "data-test": "file-period" },
      },
      [
        _vm._v(
          "\n    " +
            _vm._s(_vm._f("formatDate")(_vm.summaryFile.expiredDate)) +
            "\n  "
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "td",
      {
        staticClass: "boss-table-data text-center",
        attrs: { "data-test": "file-download" },
      },
      [
        !_vm.summaryFile.manualDeletedDate && !_vm.isExpired
          ? [
              _c(
                "button",
                {
                  staticClass: "boss-button",
                  attrs: { "data-test": "button-download" },
                  on: {
                    click: function ($event) {
                      return _vm.download(
                        _vm.summaryFile.id,
                        _vm.summaryFile.name
                      )
                    },
                  },
                },
                [_c("span", [_vm._v("ダウンロード")])]
              ),
              _vm._v(" "),
              _vm.canSendMessage
                ? _c(
                    "button",
                    {
                      staticClass: "delete-button",
                      attrs: { "data-test": "button-delete" },
                      on: {
                        click: function ($event) {
                          return _vm.doRemove(_vm.summaryFile.id)
                        },
                      },
                    },
                    [_c("span", [_vm._v("削除")])]
                  )
                : _vm._e(),
            ]
          : _c("span", { attrs: { "data-test": "delete-file" } }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.summaryFile.manualDeletedDate
                      ? _vm.summaryFile.deletedCompanyStaff +
                          "によって" +
                          _vm.$options.filters.formatDate(
                            _vm.summaryFile.manualDeletedDate
                          ) +
                          "に削除済み"
                      : "閲覧期限終了"
                  ) +
                  "\n    "
              ),
            ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }